export default __webpack_public_path__ + "static/media/top-plaque.fd6d8967.png";